import { Button, CircularProgress } from '@mui/material';

export const BpButton = ({loading, startIcon, children, ...props}) => {

  return <Button {...props} disabled={loading} startIcon={loading ? <CircularProgress size="25px" /> : startIcon}>{children}</Button>
}